import React from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { useSelector } from "react-redux";
import authenticationStatusSelector from "selectors/authenticationStatus";
import LoginBody from "./LoginBody";
import styles from "./AuthDialog.module.scss";
import SignUpBody from "./SignUpBody";

interface Props {
    description?: string;
    show: boolean;
    handleClose: () => void;
}

const AuthDialog: React.FC<Props> = ({ handleClose, show, description }) => {
    const authenticationStatus = useSelector(authenticationStatusSelector);

    React.useEffect(() => {
        if (authenticationStatus === "authenticated") {
            handleClose();
        }
    }, [authenticationStatus, handleClose]);

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Login or Sign Up</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {description && <p>{description}</p>}
                <Tabs defaultActiveKey="login">
                    <Tab eventKey="login" title="Login">
                        <div className={styles.tabContent}>
                            <LoginBody />
                        </div>
                    </Tab>
                    <Tab eventKey="signUp" title="Sign Up">
                        <div className={styles.tabContent}>
                            <SignUpBody />
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};

export default AuthDialog;
